import { render, staticRenderFns } from "./details-tag.vue?vue&type=template&id=ffe0e664&scoped=true&"
import script from "./details-tag.vue?vue&type=script&lang=js&"
export * from "./details-tag.vue?vue&type=script&lang=js&"
import style0 from "./details-tag.vue?vue&type=style&index=0&id=ffe0e664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe0e664",
  null
  
)

export default component.exports